// Stub for app/assets (stamps, user icons, etc.)
// Not used in parents app

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const stamps: any[] = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const userIcons: any[] = [];

export const getAssetsByPrefix = (_prefix: string) => {
  return [];
};

export const stampCategories: string[] = [
  "stamps/character",
  "stamps/game",
  "stamps/animal",
  "stamps/event",
  "stamps/internet",
  "stamps/money",
  "stamps/goods",
  "stamps/nature",
  "stamps/person",
  "stamps/building",
  "stamps/food",
  "stamps/electronic",
  "stamps/smile",
  "stamps/vehicle",
  "stamps/stationary",
  "stamps/others",
];
export const userIconPrefixes: string[] = ["assets/users/icons"];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const stampAssets: any = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const userIconAssets: any = {};
